<template>
    <div class="comment-form">
        <div class="form-group">
            <textarea v-model="form.body" placeholder="" class="form-control"></textarea>
        </div>
        <button class="ml-auto btn btn-sm btn-success" @click="save()" :disabled="form.isSubmitted">
            <span v-if="!form.isSubmitted">Post</span>
            <span v-else><i class="fa fa-spin fa-spinner"></i> Posting...</span>
        </button>
    </div>
</template>
<script>
    export default{

        props:{
            parentId:{
                type: Number,
                required:false,
                default: null,
            },
            video: {
                type: Object,
                required: true,
            },
            serie: {
                type: Object,
                required: true,
            },
        },

        data(){
            return {
                form: new Form({
                    body: '',
                    parent_id: this.parentId
                }),
            }
        },

        methods:{

            save(){
                this.form.post(`/videos/${this.video.id}/comments`).then(response => {
                    Alert.withAction(`Thank you for your comments, we will reach out to you as soon as possible!`).then(() => {
                        this.refreshPage();
                    })
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            }
        }
    }
</script>
